export default "__VITE_ASSET__07e3ca66__"